<template>
  <div :class="container">
    <div class="row justify-content-center">
      <div class="col">
        
<div class="row" v-if="!headless">
  <div class="col"><h5>Documents</h5></div>
  <div class="col text-right"><a href="/profile" class="blackblue"><i class="fa-solid fa-arrow-left pr-1"></i>Back to profile</a></div>
</div>

    <div class="card mb-3">
      <div class="card-header">
        <i :class="'fas '+identity_icon+' check-icon fa-lg mr-2 '+identity_status"></i>
        Identity document</div>
      <div class="card-body">

      <div v-if="loading_identity" class="p-2">   
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      </div>

      <div v-else>
        <div v-if="!headless">
          <div v-if="id_documents.length == 0">
            <div v-if="uploading_identity"><i class="fas fa-spinner fa-spin mr-2"></i><small>Uploading document ...</small></div>
<div v-else>
        <div class="mb-2">
          <small>This can be your ID or passport.</small>
        </div>
        <div class="mb-2">
          

          <form @submit="uploadDocument" enctype="multipart/form-data">
                        <label
                          for="account-upload"
                          class="btn btn-primary"
                          @click="setDocumentType('identity')">Choose file</label>
                        <input
                          type="file"
                          id="account-upload"
                          hidden
                          class="form-control mt-2"
                          v-on:change="uploadDocument"
                        />
                      </form>
          
          
          </div>
        </div>
        </div>
        </div>
         <div v-if="id_documents.length > 0">
           <div 
           v-for="(document, index) in id_documents" :key="index.id">
           <i class="far fa-file-alt mr-1"></i>
           <a :href="document.url" target="_blank" class="blacklink">View document</a>
           <span  v-if="!headless" @click="deleteDocument(document.id)" class="badge badge-pill badge-danger badge-up remove ml-2">delete</span>
           </div>
         </div>
         <small v-if="headless && id_documents.length ==0">No documents</small>
      </div>
    </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">
        <i :class="'fas '+residence_icon+' check-icon fa-lg mr-2 '+residence_status"></i>
        Proof of residence</div>
      <div class="card-body">

<div v-if="loading_residence" class="p-2">   
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      </div>

      <div v-else>
        <div v-if="!headless">
          <div v-if="residence_documents.length == 0">
            <div v-if="uploading_residence"><i class="fas fa-spinner fa-spin mr-2"></i><small>Uploading document ...</small></div>
<div v-else>
        <div class="mb-2">
          <small>Lease agreement, lease statement, utility bill, clothing or other account. Not older than 3 months.</small>
        </div>
        <div class="mb-2">
          
          <form @submit="uploadDocument" enctype="multipart/form-data">
                        <label
                          for="account-upload"
                          class="btn btn-primary"
                          @click="setDocumentType('residence')">Choose file</label>
                        <input
                          type="file"
                          id="account-upload"
                          hidden
                          class="form-control mt-2"
                          v-on:change="uploadDocument"
                        />
                      </form>
          
          </div>
        </div>
        </div>
        </div>
         <div v-if="residence_documents.length > 0">
           <div 
           v-for="(document, index) in residence_documents" :key="index.id">
           <i class="far fa-file-alt mr-1"></i>
           <a :href="document.url" target="_blank" class="blacklink">View document</a>
           <span  v-if="!headless" @click="deleteDocument(document.id)" class="badge badge-pill badge-danger badge-up remove ml-2">delete</span>
           </div>
         </div>
         <small v-if="headless && residence_documents.length ==0">No documents</small>
      </div>
    </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">
        <i :class="'fas '+bank_icon+' check-icon fa-lg mr-2 '+bank_status"></i>
        Bank statements</div>
      <div class="card-body">
        <div v-if="loading_bank" class="p-2">   
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      </div>

      <div v-else>

        <div v-if="!headless">
          <div v-if="bank_documents.length < 3">
        <div class="mb-2">
          <small>Bank statements for the last 3 months.</small>
        </div>
        <div v-if="uploading_bank"><i class="fas fa-spinner fa-spin mr-2 mb-2"></i><small>Uploading document ...</small></div>
        <div v-else>
        <div class="row pb-3">
          <div class="col">
            <v-select 
            v-model="bank_month"
            placeholder="Choose month"
                                    :options="months"
                                    label="month">
                                    <template #option="{ month }">
                                        <span>{{ month }}</span>
                                    </template>
                                    </v-select>
          </div>
          <div class="col pl-0">
            <v-select 
            v-model="bank_year"
            placeholder="Choose year"
                                    :options="years"
                                    label="year">
                                    <template #option="{ year }">
                                        <span>{{ year }}</span>
                                    </template>
                                    </v-select>
          </div>
          
        </div>
        <div class="col pl-0 pb-2">

            <form @submit="uploadDocument" enctype="multipart/form-data">
                        <label
                          for="account-upload"
                          class="btn btn-primary"
                          @click="setDocumentType('bank')">Choose file</label>
                        <input
                          type="file"
                          id="account-upload"
                          hidden
                          class="form-control mt-2"
                          v-on:change="uploadDocument"
                        />
                      </form>

          </div>
        </div>
        </div>
        </div>

        
         <div v-if="bank_documents.length > 0">
           <div class="mb-2" 
           v-for="(document, index) in bank_documents" :key="index.id">
           <i class="far fa-file-alt mr-1"></i>
           <a :href="document.url" target="_blank" class="blacklink">Bank statement - {{document.description}}</a>
           <span  v-if="!headless" @click="deleteDocument(document.id)" class="badge badge-pill badge-danger badge-up remove ml-2">delete</span>
           </div>
         </div>
        <small v-if="headless && bank_documents.length ==0">No documents</small>
      </div>
    </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">
        <i :class="'fas '+payslip_icon+' check-icon fa-lg mr-2 '+payslip_status"></i>
        Payslips</div>
      <div class="card-body">
<div v-if="loading_payslip" class="p-2">   
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      </div>

      <div v-else>
        <div v-if="!headless">
          <div v-if="payslip_documents.length < 3">
        <div class="mb-2">
          <small>Payslips for the last 3 months.</small>
        </div>
        <div v-if="uploading_payslip"><i class="fas fa-spinner fa-spin mr-2 mb-2"></i><small>Uploading document ...</small></div>
        <div v-else>
        <div class="row pb-3">
          <div class="col">
                            <v-select 
                            v-model="payslip_month"
                            placeholder="Choose month"
                            :options="months"
                            label="month">
                            <template #option="{ month }">
                                <span>{{ month }}</span>
                            </template>
                            </v-select>
          </div>
          <div class="col pl-0">
                            <v-select 
                            v-model="payslip_year"
                            placeholder="Choose year"
                            :options="years"
                            label="year">
                            <template #option="{ year }">
                                <span>{{ year }}</span>
                            </template>
                            </v-select>
          </div>
        </div>
        <div class="col pl-0 pb-2">
            <form @submit="uploadDocument" enctype="multipart/form-data">
                        <label
                          for="account-upload"
                          class="btn btn-primary"
                          @click="setDocumentType('payslip')">Choose file</label>
                        <input
                          type="file"
                          id="account-upload"
                          hidden
                          class="form-control mt-2"
                          v-on:change="uploadDocument"
                        />
                      </form>

          </div>
        </div>
        </div>
        </div>

        
         <div v-if="payslip_documents.length > 0">
           <div class="mb-2" 
           v-for="(document, index) in payslip_documents" :key="index.id">
           <i class="far fa-file-alt mr-1"></i>
           <a :href="document.url" target="_blank" class="blacklink">Payslip - {{document.description}}</a>
           <span  v-if="!headless" @click="deleteDocument(document.id)" class="badge badge-pill badge-danger badge-up remove ml-2">delete</span>
           </div>
         </div>
        <small v-if="headless && payslip_documents.length ==0">No documents</small>
      </div>
    </div>
    </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['headless','user'],

  data() {
    return {
      months: ['January','February','March','April','May','June','July','August','September','October','November','December'],
      years: [2021,2022,2023,2024,2025,2026,2027,2028,2029,2030],
      id_documents: '',
      residence_documents: '',
      bank_documents: '',
      payslip_documents: '',
      identity_status: '',
      residence_status: '',
      bank_status: '',
      payslip_status: '',
      identity_icon: '',
      residence_icon: '',
      bank_icon: '',
      payslip_icon: '',
      complete_icon: 'fa-check-circle',
      incomplete_icon: 'fa-minus-circle',
      accepted_files: ".png,.jpg,.jpeg,.pdf",
      document_type: '',
      uploading_identity: false,
      uploading_residence: false,
      uploading_bank: false,
      uploading_payslip: false,
      bank_month: '',
      bank_year: '',
      payslip_month: '',
      payslip_year: '',
      container: '',
      loading_identity: false,
      loading_residence: false,
      loading_bank: false,
      loading_payslip: false,
    };
  },

  created() {

    this.getIdentity();
    this.getResidence();
    this.getBank();
    this.getPayslip();

    if (!this.headless) this.container = 'container'; 
    else this.container = '';
    
  },

  methods: {

     async uploadDocument(e) {

       this.file = e.target.files[0];

      let existingObj = this;

      var document_response = this.document_check(this.file,'document');

      if (document_response.success !== true) this.sweetfire(document_response.message);

      else {

          if (this.document_type=='bank' && (this.bank_month=='' || this.bank_month==null)) {this.sweetfire('Please choose month for bank statement')}
          else if (this.document_type=='bank' && (this.bank_year=='' || this.bank_year==null)) {this.sweetfire('Please choose year for bank statement')}
          else if (this.document_type=='payslip' && (this.payslip_month=='' || this.payslip_month==null)) {this.sweetfire('Please choose month for payslip')}
          else if (this.document_type=='payslip' && (this.payslip_year=='' || this.payslip_year==null)) {this.sweetfire('Please choose year for payslip')}
          else {

          if (this.document_type == 'identity') this.uploading_identity = true;
          else if (this.document_type == 'residence') this.uploading_residence = true;
          else if (this.document_type == 'bank') this.uploading_bank = true;
          else if (this.document_type == 'payslip') this.uploading_payslip = true;

          const config = { headers: { "content-type": "multipart/form-data", }, };

          let data = new FormData();
          data.append("file", this.file);
          data.append("type", this.document_type);
          data.append("bank_month", this.bank_month);
          data.append("bank_year", this.bank_year);
          data.append("payslip_month", this.payslip_month);
          data.append("payslip_year", this.payslip_year);

          await axios
            .post("/documents/upload", data, config)
            .then(function (response) {
              console.log(response.data);
              if (existingObj.document_type == 'identity') {
                existingObj.getIdentity(); 
                existingObj.uploading_identity = false;
                }
              else if (existingObj.document_type == 'residence') {
                existingObj.getResidence();
                existingObj.uploading_residence = false;
              }
              else if (existingObj.document_type == 'bank') {
                existingObj.getBank();
                existingObj.uploading_bank = false;
                existingObj.bank_month = '';
                existingObj.bank_year = '';
              }
              else if (existingObj.document_type == 'payslip') {
                existingObj.getPayslip();
                existingObj.uploading_payslip = false;
                existingObj.payslip_month = '';
                existingObj.payslip_year = '';
              }
              
            })
            .catch(function (err) {
              console.log(err);
              existingObj.uploading_identity = false;
              existingObj.uploading_residence = false;
              existingObj.uploading_bank = false;
              existingObj.uploading_payslip = false;
            });

          }

      }

    },

    sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  

    setDocumentType(clicked) {
      this.document_type = clicked;
    },

    deleteDocument(document_id) {

      Swal.fire({
      title: 'Are you sure you want to delete this document?',
      showConfirmButton: false,
      showDenyButton: true,
      showCancelButton: true,
      focusConfirm: false,
      // position: 'top',
      // showCloseButton: true,
      // confirmButtonText: 'Yes, delete it',
      denyButtonText: 'Yes, delete it',
      customClass: {
              title: "popup-title",
            },
    }).then((result) => {

    if (result.isDenied) {
        
        this.deleteDocumentAction(document_id);

        Swal.fire({
          timer: 2000,
          title: 'Document has been deleted',
          showConfirmButton: false,
        customClass: {
              title: "popup-title",
            }});
      } 

    })

    },

    deleteDocumentAction(document_id) {

      let existingObj = this;

      axios
        .post("/documents/delete", {document_id: document_id})
        .then(function (response) {
          console.log(response.data);
          existingObj.getIdentity();
          existingObj.getResidence();
          existingObj.getBank();
          existingObj.getPayslip();
        })
        .catch(function (err) {
          console.log(err);
        });

    },

    getIdentity() {

      this.loading_identity = true;

      axios
        .get("/documents/get-identity/"+this.user.id)
        .then((response) => {
          this.id_documents = response.data;

          if (this.id_documents.length > 0) {
            this.identity_status = 'complete';
            this.identity_icon = this.complete_icon;
          } else {
            this.identity_status = 'incomplete';
            this.identity_icon = this.incomplete_icon;
          }

          this.loading_identity = false;

        })
        .catch(function (error) {
          console.log(error);
          this.loading_identity = false;
        });
    },

    getResidence() {

      this.loading_residence = true;

      axios
        .get("/documents/get-residence/"+this.user.id)
        .then((response) => {
          this.residence_documents = response.data;

        if (this.residence_documents.length > 0) {
            this.residence_status = 'complete';
            this.residence_icon = this.complete_icon;
          } else {
            this.residence_status = 'incomplete';
            this.residence_icon = this.incomplete_icon;
          }

          this.loading_residence = false;

        })
        .catch(function (error) {
          console.log(error);
          this.loading_residence = false;
        });
    },

    getBank() {
      this.loading_bank = true;
      axios
        .get("/documents/get-bank/"+this.user.id)
        .then((response) => {
          this.bank_documents = response.data;

          if (this.bank_documents.length > 0) {
            this.bank_status = 'complete';
            this.bank_icon = this.complete_icon;
          } else {
            this.bank_status = 'incomplete';
            this.bank_icon = this.incomplete_icon;
          }

          this.loading_bank = false;

        })
        .catch(function (error) {
          console.log(error);
          this.loading_bank = false;
        });
    },

    getPayslip() {
      this.loading_payslip = true;
      axios
        .get("/documents/get-payslip/"+this.user.id)
        .then((response) => {
          this.payslip_documents = response.data;

          if (this.payslip_documents.length > 0) {
            this.payslip_status = 'complete';
            this.payslip_icon = this.complete_icon;
          } else {
            this.payslip_status = 'incomplete';
            this.payslip_icon = this.incomplete_icon;
          }

          this.loading_payslip = false;

        })
        .catch(function (error) {
          console.log(error);
          this.loading_payslip = false;
        });
    },

  },
};
</script> 

<style scoped>
.complete {color:#28a745}
.incomplete {color: #dc3545;}
.remove {padding: 0.3rem 0.4rem; margin-bottom:0.1rem;}
.remove:hover {cursor: pointer;}
.badge { font-weight: normal; font-size: 65%; border-radius: 0.25rem;}
</style>